var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("form", { attrs: { "data-vv-scope": "flow-part-1" } }, [
      _c("div", { staticClass: "row mb-3" }, [
        _c("div", { staticClass: "col-12" }, [
          _c("h4", [_vm._v("Datos para el flujo")]),
          _c("span", [
            _vm._v(" Este expediente "),
            _vm.wizardData.fileCategory === "numInt"
              ? _c("span", [_vm._v(" podrá tener numeración interna ")])
              : _vm._e(),
            _vm.wizardData.fileCategory === "numOf"
              ? _c("span", [
                  _vm._v(" podrá ser tramitado por Oficina de Partes ")
                ])
              : _vm._e()
          ])
        ])
      ]),
      _c("div", { staticClass: "row mb-3" }, [
        _c(
          "div",
          { staticClass: "col-md-6" },
          [
            _c("vs-input", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required",
                  expression: "'required'"
                }
              ],
              staticClass: "w-100",
              attrs: {
                label: "Nombre para el flujo",
                maxlength: "120",
                name: "name",
                danger: _vm.errors.has("flow-part-1.name"),
                "danger-text": _vm.errors.first("flow-part-1.name")
              },
              model: {
                value: _vm.step.name,
                callback: function($$v) {
                  _vm.$set(_vm.step, "name", $$v)
                },
                expression: "step.name"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-md-6" },
          [
            _c("vs-input", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required",
                  expression: "'required'"
                }
              ],
              staticClass: "w-100",
              attrs: {
                label: "Descripción para el flujo",
                name: "description",
                danger: _vm.errors.has("flow-part-1.description"),
                "danger-text": _vm.errors.first("flow-part-1.description"),
                maxlength: "550"
              },
              model: {
                value: _vm.step.description,
                callback: function($$v) {
                  _vm.$set(_vm.step, "description", $$v)
                },
                expression: "step.description"
              }
            })
          ],
          1
        )
      ]),
      _c("div", { staticClass: "row mb-3" }, [
        _c("div", { staticClass: "col-md-6" }, [
          _c("div", { staticClass: "row" }, [
            _vm._m(0),
            _c(
              "div",
              { staticClass: "col-md-1" },
              [
                _c(
                  "vs-radio",
                  {
                    attrs: {
                      "vs-name": "pdfStamp",
                      "vs-value": true,
                      "data-cy": "pdfStampYes"
                    },
                    model: {
                      value: _vm.step.pdfStamp,
                      callback: function($$v) {
                        _vm.$set(_vm.step, "pdfStamp", $$v)
                      },
                      expression: "step.pdfStamp"
                    }
                  },
                  [_vm._v(" Si ")]
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-md-1" },
              [
                _c(
                  "vs-radio",
                  {
                    attrs: {
                      "vs-name": "pdfStamp",
                      "vs-value": false,
                      "data-cy": "pdfStampNo"
                    },
                    model: {
                      value: _vm.step.pdfStamp,
                      callback: function($$v) {
                        _vm.$set(_vm.step, "pdfStamp", $$v)
                      },
                      expression: "step.pdfStamp"
                    }
                  },
                  [_vm._v(" No ")]
                )
              ],
              1
            )
          ])
        ]),
        _c("div", { staticClass: "col-md-6" })
      ])
    ]),
    _c("form", { attrs: { "data-vv-scope": "flow-part-2" } }, [
      _vm._m(1),
      _c("div", { staticClass: "row mb-5" }, [
        _c(
          "div",
          { staticClass: "col-3" },
          [
            _c(
              "vs-select",
              {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                staticClass: "w-100",
                attrs: {
                  autocomplete: "",
                  label: "Tipo de paso",
                  name: "stepType",
                  danger: _vm.errors.has("flow-part-2.stepType"),
                  "danger-text": _vm.errors.first("flow-part-2.stepType")
                },
                on: { change: _vm.searchOffice },
                model: {
                  value: _vm.stepType,
                  callback: function($$v) {
                    _vm.stepType = $$v
                  },
                  expression: "stepType"
                }
              },
              [
                _c("vs-select-item", {
                  attrs: { value: _vm.stepTypes.USER, text: "Usuario" }
                }),
                _c("vs-select-item", {
                  attrs: { value: _vm.stepTypes.GROUP, text: "Grupo" }
                }),
                _c("vs-select-item", {
                  attrs: { value: _vm.stepTypes.OFFICE, text: "Oficina" }
                })
              ],
              1
            )
          ],
          1
        ),
        _vm.stepType === _vm.stepTypes.GROUP
          ? _c(
              "div",
              { staticClass: "col-6" },
              [
                _c("list-groups", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: { required: _vm.stepType === _vm.stepTypes.GROUP },
                      expression: "{ required: stepType === stepTypes.GROUP }"
                    }
                  ],
                  ref: "groupStep",
                  staticClass: "w-100",
                  attrs: {
                    autocomplete: "",
                    label: "Grupo del responsable",
                    name: "groupStep",
                    typeList: _vm.stepType,
                    officeType: _vm.wizardData.fileCategory,
                    danger: _vm.errors.has("flow-part-2.groupStep"),
                    "danger-text": _vm.errors.first("flow-part-2.groupStep")
                  },
                  model: {
                    value: _vm.groupStep,
                    callback: function($$v) {
                      _vm.groupStep = $$v
                    },
                    expression: "groupStep"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm.stepType === this.stepTypes.OFFICE
          ? _c(
              "div",
              { staticClass: "col-6" },
              [
                _c("list-offices", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: {
                        required: _vm.stepType === this.stepTypes.OFFICE
                      },
                      expression:
                        "{ required: stepType === this.stepTypes.OFFICE }"
                    }
                  ],
                  ref: "groupStep",
                  staticClass: "w-100",
                  attrs: {
                    autocomplete: "",
                    label: "Oficina del responsable",
                    name: "groupStep",
                    typeList: _vm.stepType,
                    officeType: _vm.wizardData.fileCategory,
                    danger: _vm.errors.has("flow-part-2.groupStep"),
                    "danger-text": _vm.errors.first("flow-part-2.groupStep")
                  },
                  model: {
                    value: _vm.groupStep,
                    callback: function($$v) {
                      _vm.groupStep = $$v
                    },
                    expression: "groupStep"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm.stepType === _vm.stepTypes.USER
          ? _c(
              "div",
              { staticClass: "col-6" },
              [
                _c("list-user", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: { required: _vm.stepType === _vm.stepTypes.USER },
                      expression: "{ required: stepType === stepTypes.USER }"
                    }
                  ],
                  ref: "userStep",
                  staticClass: "w-100",
                  attrs: {
                    autocomplete: "",
                    label: "Usuario",
                    name: "userStep",
                    danger: _vm.errors.has("flow-part-2.userStep"),
                    "danger-text": _vm.errors.first("flow-part-2.userStep")
                  },
                  model: {
                    value: _vm.userStep,
                    callback: function($$v) {
                      _vm.userStep = $$v
                    },
                    expression: "userStep"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm.stepType !== _vm.stepTypes.OFFICE
          ? _c(
              "div",
              { staticClass: "col-3" },
              [
                _c(
                  "vs-select",
                  {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    staticClass: "w-100",
                    attrs: {
                      autocomplete: "",
                      label: "Tipo de rol",
                      name: "rolType",
                      danger: _vm.errors.has("flow-part-2.rolType"),
                      "danger-text": _vm.errors.first("flow-part-2.rolType")
                    },
                    model: {
                      value: _vm.rolType,
                      callback: function($$v) {
                        _vm.rolType = $$v
                      },
                      expression: "rolType"
                    }
                  },
                  [
                    _c("vs-select-item", {
                      attrs: { value: _vm.rolTypes.APPROVER, text: "Aprobador" }
                    }),
                    _c("vs-select-item", {
                      attrs: { value: _vm.rolTypes.REVIEWER, text: "Revisor" }
                    }),
                    _c("vs-select-item", {
                      attrs: { value: _vm.rolTypes.SIGNER, text: "Firmante" }
                    })
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e(),
        _vm.stepType === _vm.stepTypes.OFFICE
          ? _c(
              "div",
              { staticClass: "col-3" },
              [
                _c(
                  "vs-select",
                  {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    staticClass: "w-100",
                    attrs: {
                      autocomplete: "",
                      label: "Tipo de rol",
                      name: "rolType",
                      danger: _vm.errors.has("flow-part-2.rolType"),
                      "danger-text": _vm.errors.first("flow-part-2.rolType")
                    },
                    model: {
                      value: _vm.rolType,
                      callback: function($$v) {
                        _vm.rolType = $$v
                      },
                      expression: "rolType"
                    }
                  },
                  [
                    _c("vs-select-item", {
                      attrs: {
                        value: _vm.rolTypes.SIGNER,
                        text: "Numerar/Tramitar"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e()
      ]),
      _c("div", { staticClass: "row mb-3" }, [
        _c(
          "div",
          { staticClass: "col-12 d-flex align-items-end justify-content-end" },
          [
            _c(
              "vs-button",
              {
                attrs: {
                  color: "primary",
                  icon: "add",
                  disabled: _vm.blockButton,
                  "data-cy": "add-step"
                },
                on: {
                  click: function($event) {
                    return _vm.addStep()
                  }
                }
              },
              [_vm._v(" Agregar Paso ")]
            )
          ],
          1
        )
      ]),
      _vm.step.steps.length
        ? _c(
            "div",
            { staticClass: "row mb-3" },
            _vm._l(_vm.step.steps, function(step, index) {
              return _c("div", { key: "step-" + index, staticClass: "col-3" }, [
                _c("div", { staticClass: "step-wrapper" }, [
                  _c("span", { staticClass: "step-number" }, [
                    _vm._v(_vm._s(step.stepNumber))
                  ]),
                  _c(
                    "span",
                    { staticClass: "step-delete" },
                    [
                      _c("vs-icon", {
                        attrs: {
                          icon: "highlight_off",
                          size: "small",
                          bg: "white",
                          round: ""
                        },
                        on: {
                          click: function($event) {
                            return _vm.removeStep(step)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c("div", { staticClass: "text-center step-name" }, [
                    _vm._v(" " + _vm._s(step.responsibleName) + " "),
                    step.stepType === _vm.stepTypes.GROUP ||
                    step.stepType === _vm.stepTypes.OFFICE
                      ? _c("span", [
                          _vm._v(" " + _vm._s(step.groupUsers.length) + " ")
                        ])
                      : _vm._e()
                  ]),
                  _c("div", { staticClass: "step-type" }, [
                    step.stepType === _vm.stepTypes.USER
                      ? _c("span", [_vm._v(" usuario ")])
                      : _vm._e(),
                    step.stepType === _vm.stepTypes.GROUP
                      ? _c("span", [_vm._v(" grupo ")])
                      : _vm._e(),
                    step.stepType === _vm.stepTypes.OFFICE
                      ? _c("span", [_vm._v(" oficina ")])
                      : _vm._e()
                  ]),
                  _c("div", { staticClass: "step-rol" }, [
                    step.rolType === _vm.rolTypes.APPROVER
                      ? _c("span", [_vm._v(" aprobador ")])
                      : _vm._e(),
                    step.stepType !== _vm.stepTypes.OFFICE &&
                    step.rolType === _vm.rolTypes.SIGNER
                      ? _c("span", [_vm._v(" firmante ")])
                      : _vm._e(),
                    step.rolType === _vm.rolTypes.REVIEWER
                      ? _c("span", [_vm._v(" revisor ")])
                      : _vm._e(),
                    step.stepType === _vm.stepTypes.OFFICE &&
                    step.rolType === _vm.rolTypes.SIGNER
                      ? _c("span", [_vm._v(" num/tramitar ")])
                      : _vm._e()
                  ])
                ])
              ])
            }),
            0
          )
        : _vm._e(),
      _vm.error.message !== ""
        ? _c(
            "div",
            {
              staticClass:
                "con-text-validation span-text-validation-danger\n         vs-input--text-validation-span v-enter-to text-right",
              staticStyle: { height: "32px" }
            },
            [
              _c("span", { staticClass: "span-text-validation" }, [
                _vm._v(" " + _vm._s(_vm.error.message) + " ")
              ])
            ]
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-3" }, [
      _c("label", [_vm._v("Estampar aprobaciones")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row mb-3" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("h4", [_vm._v("Detalle del flujo")])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }